import { render } from "./ResultadoInfo.vue?vue&type=template&id=7e98162a&ts=true"
import script from "./ResultadoInfo.vue?vue&type=script&lang=ts"
export * from "./ResultadoInfo.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__